import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { AddressList } from '../../common/EmailDetails';
import { staggeredBaseQuery } from './staggeredBaseQuery'; 

export const emailApi = createApi({
  reducerPath: 'emailApi',
  tagTypes: ['Email'],
  baseQuery: staggeredBaseQuery(''),
  endpoints: (builder) => ({
    getAddressList: builder.query<AddressList, {}>({
      query: () => {
        return {
          method: 'GET',
          url: `emails/addressList`,
        };
      },
      providesTags: [{ type: 'Email', id: 'LIST' }]
    }),
    sendEmail: builder.mutation<void, FormData>({
      query: (data) => {
        return {
          method: 'POST',
          url: 'emails/send',
          body: data,
        };
      },
      invalidatesTags: [{ type: 'Email', id: 'LIST' }],
    }),
  }),
});

export const {
  useGetAddressListQuery,
  useSendEmailMutation,
} = emailApi;